module.exports = __webpack_public_path__ + "static/media/8300.311a300f.jpg";